import { render, staticRenderFns } from "./AccessesTable.vue?vue&type=template&id=60a7ecc2"
import script from "./AccessesTable.vue?vue&type=script&lang=js"
export * from "./AccessesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports